/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { EnumOrganizationPolicySettingNameFromJSON, EnumOrganizationPolicySettingNameToJSON } from './EnumOrganizationPolicySettingName';
export function OrganizationPolicySettingFromJSON(json) {
    return OrganizationPolicySettingFromJSONTyped(json, false);
}
export function OrganizationPolicySettingFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: !exists(json, 'id') ? undefined : json['id'],
        label: !exists(json, 'label') ? undefined : json['label'],
        name: !exists(json, 'name') ? undefined : EnumOrganizationPolicySettingNameFromJSON(json['name']),
        url: !exists(json, 'url') ? undefined : json['url'],
        createdAt: !exists(json, 'created_at') ? undefined : json['created_at'],
        updatedAt: !exists(json, 'updated_at') ? undefined : json['updated_at']
    };
}
export function OrganizationPolicySettingToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        label: value.label,
        name: EnumOrganizationPolicySettingNameToJSON(value.name),
        url: value.url,
        created_at: value.createdAt,
        updated_at: value.updatedAt
    };
}
